import { render, staticRenderFns } from "./MoreInfoDialog.vue?vue&type=template&id=1089b88c&scoped=true"
import script from "./MoreInfoDialog.vue?vue&type=script&lang=js"
export * from "./MoreInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089b88c",
  null
  
)

export default component.exports